import { Box, CircularProgress } from "@mui/material";

export default function FullPageLoader() {
  return (
    <Box
      sx={{
        position: "absolute",
        margin: "auto",
        top: "40%",
        left: "40%",
        width: "200px",
      }}
    >
      <CircularProgress size={100} color="primary" value={50} />
    </Box>
  );
}
